// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__tBZWH","location":"Header_location__3ejZ2"};